import { useEffect, useMemo, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";
import ThirdPartyReportService from "src/modules/data-protection/apis/ThirdPartyReportService";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { REPORT_STATUS_LIST } from "src/components/constants";

const FilteringComponent = ({
    t,
    onChange
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        status: null,
        category: null
    });

    const handleFetchCategories = useQuery({
        queryKey: ["gdpr-fetch-reports-categories"],
        queryFn: async () => {
            const service = ThirdPartyReportService.getInstance();

            return await service.FetchCategories();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(t("An error occurred while fetching categories."), {
                type: "error",
            });
        },
    });

    const statuses = useMemo(() => {
        return REPORT_STATUS_LIST.map((status) => {
            return {
                id: status.id,
                title: t(status.titleKey)
            }
        });
    }, [
        t
    ]);

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'category',
                title: 'Category',
                icon: <i className="ri-filter-3-line" />,
                isLoading: handleFetchCategories.isFetching,
                defaultValue: tableFilters?.category,
                data: handleFetchCategories.data || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return t(item.title) 
                }
            },
            {
                type: 'radio_list',
                name: 'status',
                title: 'Status',
                icon: <i className="ri-toggle-line" />,
                isLoading: false,
                defaultValue: tableFilters?.status,
                data: statuses,
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.title
                }
            }
        ]
    }, [
        tableFilters,
        handleFetchCategories.isFetching,
        handleFetchCategories.data,
        statuses,
        t
    ]);

    const onTableFilterOkButtonClicked = (filters) => {
        if (filters) {
            const result = {}
            if ('status' in filters) {
                result.status = filters.status !== 'all' ? filters.status : undefined
            }

            if ('category' in filters) {
                result.category = filters.category !== 'all' ? filters.category : undefined
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                status: null,
                category: null
            })
        }
    }

    useEffect(() => {
        onChange && onChange(tableFilters)
    }, [ 
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='category'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);